// note(juan): this is a false-positive due to an ESlint error https://stackoverflow.com/questions/63961803/eslint-says-all-enums-in-typescript-app-are-already-declared-in-the-upper-scope
 
export enum LearningPathStepID {
  strategyOverview,
  howToUseIt,
  helpfulTips,
  knowledgeCheck,
}

export const LEARNING_PATH_STEPPER_STEP_IDS: Record<LearningPathStepID, string> = {
  [LearningPathStepID.strategyOverview]: 'strategyOverview',
  [LearningPathStepID.howToUseIt]: 'howToUseIt',
  [LearningPathStepID.helpfulTips]: 'helpfulTips',
  [LearningPathStepID.knowledgeCheck]: 'knowledgeCheck',
};
